import {
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';

const AuthContext =
  createContext();

export function AuthProvider({
  children
}) {

  const [user, setUser] =
    useState(null);

  const [token, setToken] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  // ====================================
  // RECUPERAR SESIÓN
  // ====================================

  useEffect(() => {

    const savedToken =
      localStorage.getItem(
        'maccez_token'
      );

    const savedUser =
      localStorage.getItem(
        'maccez_user'
      );

    if (
      savedToken &&
      savedUser
    ) {

      setToken(savedToken);

      setUser(
        JSON.parse(savedUser)
      );

    }

    setLoading(false);

  }, []);

  // ====================================
  // LOGIN
  // ====================================

  const login = async ({
    email,
    password
  }) => {

    try {

      const response =
        await fetch(
          '/api/login',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json'
            },

            body: JSON.stringify({
              email,
              password
            })
          }
        );

      const data =
        await response.json();

      if (!response.ok) {

        return {
          success: false,
          message:
            data.message
        };

      }

      // GUARDAR SESIÓN
      localStorage.setItem(
        'maccez_token',
        data.token
      );

      localStorage.setItem(
        'maccez_user',
        JSON.stringify(
          data.user
        )
      );

      setToken(data.token);

      setUser(data.user);

      return {
        success: true
      };

    } catch (error) {

      return {
        success: false,
        message:
          'Error conexión servidor'
      };

    }

  };

  // ====================================
  // LOGOUT
  // ====================================

  const logout = () => {

    localStorage.removeItem(
      'maccez_token'
    );

    localStorage.removeItem(
      'maccez_user'
    );

    setToken(null);

    setUser(null);

  };

  return (

    <AuthContext.Provider
      value={{
        user,
        token,
        login,
        logout,
        loading,
        isAuthenticated:
          !!token
      }}
    >

      {children}

    </AuthContext.Provider>

  );

}

export function useAuth() {

  return useContext(
    AuthContext
  );

}